import React from 'react';
import Avatar from 'material-ui/Avatar';
import ReportProblem from 'material-ui/svg-icons/action/report-problem';
import Display from './Display';
import {
  Card,
  CardHeader,
  CardText,
} from 'material-ui/Card';
import {
  setAppBar,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';
import { displayListAppBar } from './util';
import { connect } from 'react-redux';

class WysiwygList extends React.Component {

  static PropTypes = {
    currentFilter: React.PropTypes.number,
  }

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.context.store.dispatch(setAppBar(displayListAppBar));
    this.wysiwygs = this.getWysiwygs();
    this.renderWysiwygs = ::this.renderWysiwygs;
  }

  getWysiwygs() {
    const displays = this.context.store.getState().app.displays.items;
    return displays.map((display) => {
      let avatar = null;
      if (display.offLineOn_LAN1 || display.offLineOn_LAN2) {
        avatar = <Avatar icon={<ReportProblem />} />
      }
      return (
        <Card
          key={display.id}
          style={ { margin: '10px' } }
          data-departmentid={display.departmentId}
        >
          <CardHeader
            title={display.name}
            subtitle={display.shortDescription}
            avatar={avatar}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <Display
              display={display}
              expandDisplayForm={false}
              setAppBar={false}
              hideCancel
            />
          </CardText>
        </Card>
      );
    });
  }

  renderWysiwygs() {
    let result = [];
    const { currentFilter } = this.props;
    if (!currentFilter) {
      result = [...this.wysiwygs];
    } else {
      for (const wysiwyg of this.wysiwygs) {
        if (wysiwyg.props['data-departmentid'] === currentFilter) {
          result.push(wysiwyg);
        }
      }
    }
    return result;
  }

  render() {
    return (
      <div>
        {this.renderWysiwygs()}
      </div>
    );
  }
}

export default connect((state) => ({
  currentFilter: state.app.displays.list.currentFilter,
}))(WysiwygList);



/** WEBPACK FOOTER **
 ** ./src/routes/Display/WysiwygList.js
 **/